<style lang="scss" scoped>
    .card-box {
        cursor: move;
        position: relative;
        // overflow: hidden;
        margin-bottom: 5px;
        padding: 10px;
        transition: all 0.1s ease-out;
        -webkit-transition: all 0.1s ease-out;

        .box_cards {
            display: -webkit-flex;
            display: flex;
            position: relative;

            .infos_kanban {
                width: 212px;
            }
        }

        .add_fast {
            display: flex;
            height: 1px;
            width: calc(100% + 20px);
            margin: 10px -10px -10px;
            opacity: 0;
            visibility: hidden;
            transition: all 0.2s ease-out;
            -webkit-transition: all 0.2s ease-out;
            -webkit-transition-delay: 0s;
            transition-delay: 0s;

            .btn {
                height: 100%;
                width: 33.333%;
                border-radius: 0;
                border-bottom: none!important;
                border-left: none!important;

                &:last-child {
                    border-right: none!important;
                    border-radius: 0 0 5px 0;
                }
            }
        }

        &.drag_none {
            cursor: no-drop;
        }

        .status_deal {
            right: 6px;
        }

        &.ghost {
            opacity: 1;
            background: #e8e8e8!important;
            border-color: #e8e8e8!important;
            box-shadow: inset -2px -2px 1px rgba(0,0,0,0.08);
            transform: rotate(0) scale(1)!important;
            -webkit-transform: rotate(0) scale(1)!important;
            -moz-transform: rotate(0) scale(1)!important;
        }

        &:hover {
            box-shadow: 0px 4px 17px -7px rgba(0, 0, 0, 0.5);
            transform: translate(0, -2px);
            -webkit-transform: translate(0, -2px);
            -moz-transform: translate(0, -2px);

            .add_fast {
                height: 28px;
                opacity: 1;
                visibility: visible;
                -webkit-transition-delay: 0.8s;
                transition-delay: 0.8s;
            }
        }

        &.sortable-chosen {
            transform: rotate(3deg) scale(0.95);
            -webkit-transform: rotate(3deg) scale(0.95);
            -moz-transform: rotate(3deg) scale(0.95);
        }
    }
</style>

<template>
    <div :class="(item.status !== 'open') ? 'card-box m-t-5 card_color_left' : 'card-box card_color_left'" :style="`border-left-color: ${segment.color}`">
        <span v-if="item.status !== 'open'" class="status_deal" :class="{ 'sold': item.status === 'sold', 'lost': item.status === 'lost' }">{{ $t(item.status) }}</span>
        <div :class="(item.status !== 'open') ? 'source_kanban m-t-10' : 'source_kanban'" v-pml-tooltip.bottom-left="source.name" v-if="item.source_id">
            <i class="fa fa-circle" :style="`color:${source.color}`"></i>
        </div>
        <div class="box_cards">
            <router-link :to="{ name: 'deals.show', params: { id: item.id } }" class="w_32">
                <img class="img-circle thumb-sm" :src="item.avatar || '/static/images/avatar.jpg'" :title="fullName">
                <div class="show m-t-5 t_center" v-pml-tooltip.right="$t(item.perception)" v-if="item.perception">
                    <span class="label" :class="getPerceptionColor(item.perception)">
                        <i class="fa-fw fa" :class="getPerceptionIcon(item.perception)"></i>
                    </span>
                </div>
            </router-link>
            <div class="infos_kanban p-l-10">
                <router-link :to="{ name: 'deals.show', params: { id: item.id } }" class="show p-r-10">
                    <strong class="m-t-0 f_size_14 show">
                        #{{ item.code }}
                        <span v-if="item.first_name"> - {{ fullName }}</span>
                    </strong>
                    <small class="show m-t-5 t_overflow" v-if="item.reference">({{ item.reference }})</small>
                </router-link>
                <small class="m-t-5 c_default show bold t_overflow" v-if="item.email">{{ item.email }}</small>
                <small v-if="item.member_id && item.member_id !== selectedMember" class="m-t-5 text-muted" v-pml-tooltip="$t('consultant')">
                    <i class="fa md-headset-mic text-dark m-r-5"></i> {{ item.member_id | pmlMemberById('full_name') }}
                </small>
                <div class="clearfix"></div>
                <small v-if="item.follower_id" class="m-t-5 text-muted" v-pml-tooltip="$t('follower')">
                    <i class="fa fa-location-arrow text-dark m-r-5"></i> {{ item.follower_id | pmlMemberById('full_name') }}
                </small>
            </div>
        </div>
        <div class="add_fast">
            <button class="btn btn-xs btn-white" v-pml-tooltip.top-right="$t('add_follow_up')" @click.prevent="callToAction('follow-ups.create')"><i class="fa fa-history"></i></button>
            <button class="btn btn-xs btn-white" v-pml-tooltip="$t('add_task')" @click.prevent="callToAction('calendar.create')"><i class="fa fa-tasks"></i></button>
            <button class="btn btn-xs btn-white" v-pml-tooltip.top-left="$t('send_email')" @click.prevent="callToAction('sent-emails.create')"><i class="fa fa-envelope-o"></i></button>
        </div>
    </div>
</template>

<script>
    import { isNull } from 'lodash'
    import { findSegment, findSource } from 'utils/helpers/find-store'

    export default {
        name: 'KanbanView',
        props: [ 'item', 'selectedMember' ],
        computed: {
            fullName () {
                if (!isNull(this.item.first_name) || !isNull(this.item.last_name)) {
                    const firstName = !isNull(this.item.first_name) ? this.item.first_name.trim() : ''
                    const lastName = !isNull(this.item.last_name) ? this.item.last_name.trim() : ''

                    return `${firstName} ${lastName}`.trim()
                }

                return this.item.email
            },
            segment () {
                return findSegment(this.item.segment_id) || {}
            },
            source () {
                return findSource(this.item.source_id) || {}
            }
        },
        methods: {
            getPerceptionIcon (perception) {
                if (perception === 'cold') return 'fa-cube'
                if (perception === 'warm') return 'fa-tint'
                if (perception === 'hot') return 'fa-fire'
                if (perception === 'no_perception') return 'fa-ban'
            },
            getPerceptionColor (persption) {
                if (persption === 'hot') return 'label-danger'
                if (persption === 'cold') return 'label-primary'
                if (persption === 'warm') return 'label-warning'
                if (persption === 'no_perception') return 'label-light'
            },
            callToAction (name) {
                window.sessionStorage.setItem('pipeline_card_action_deal_id', this.item.id)
                this.$router.push({ name })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/pipeline/components/Card.vue